<template>
    <div class="tabletBody message_line">
        <div class="container">
            <div class="row">
                <div class="align-items-center d-flex flex-wrap h-100 justify-content-between position-absolute text-center thank_you">
                    <div class="d-flex flex-column kaz w-100">
                        <span class="thnx">Рахмет!</span>
                        <span class="desc">Сіздің рейтингіңіз қабылданды</span>
                    </div>
                    <div class="d-flex flex-column rus w-100">
                        <span class="thnx">Спасибо!</span>
                        <span class="desc">Ваша оценка принята</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "thakyouPage"
    }
</script>

<style scoped>

</style>